import React from "react";
import dayjs, { Dayjs } from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

export interface DateTimePickerProps {
  id: string;
  label: string;
  value: string | null;
  helperText?: string;
  required?: boolean;
  disabled?: boolean;
  onChange(id: string, value: any | null): void;
}

dayjs.extend(customParseFormat);

const parseDateOnly = (value: string | null | undefined): Dayjs | null => {
  if (value === undefined || value === null || value === "") return null;
  const parsed = dayjs(value, "YYYY-MM-DD", true);
  return parsed.isValid() ? parsed : null;
};

const DateTimePicker: React.FC<DateTimePickerProps> = ({
  id,
  label,
  value,
  helperText,
  required,
  disabled,
  onChange,
}) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        label={label}
        value={parseDateOnly(value)}
        disabled={disabled}
        sx={{ mb: 3 }}
        slotProps={{
          textField: {
            id: id,
            helperText: helperText,
            required: required,
            size: "small",
            fullWidth: true,
          },
        }}
        onChange={(value) => {
          if (value?.isValid()) onChange(id, value.format("YYYY-MM-DD"));
        }}
      />
    </LocalizationProvider>
  );
};

export default DateTimePicker;
